// types
export const SET_DRAWER = 'SET_DRAWER';
export const SET_DRAWER_OPEN = 'SET_DRAWER_OPEN';
export const SET_DRAWER_CLOSE = 'SET_DRAWER_CLOSE';
export const TOGGLE_DRAWER = 'TOGGLE_DRAWER';

// drawer ids
export const USER_DRAWER = 'USER_DRAWER';
export const CONTENT_DRAWER = 'CONTENT_DRAWER';

// actions
export const setDrawerClose = {
  type: SET_DRAWER_CLOSE
}

export const setDrawerOpen = {
  type: SET_DRAWER_OPEN
}

export const toggleDrawer = {
  type: TOGGLE_DRAWER
}

export const setDrawer = (drawerID) => {
  return {
    type: SET_DRAWER,
    payload: {
      drawerID
    }
  }
}

export const setToUserDrawer = {
  type: SET_DRAWER,
  payload: {
    drawerID: USER_DRAWER
  }
}

export const setToContentDrawer = {
  type: SET_DRAWER,
  payload: {
    drawerID: CONTENT_DRAWER
  }
}